import {
  SET_STATUS_UPDATE_PLAN,
  RESET_IMPORT_STATUS_UPDATE,
  SET_IS_APPLYING_STATUS_UPDATE,
  SET_IS_PLANNING_STATUS_UPDATE,
  SET_STATUS_UPDATE_ERROR,
  SET_STATUS_UPDATE_MODE,
  SET_STATUS_UPDATE_FILE,
} from '../actions/actionTypes';
import { StatusUpdateAction, StatusUpdateStateType } from '../context';

export default (
  state: StatusUpdateStateType,
  action: StatusUpdateAction,
): StatusUpdateStateType => {
  switch (action.type) {
    case SET_STATUS_UPDATE_FILE:
      return {
        ...state,
        fileName: action.payload.name,
        fileContents: action.payload.contents,
      };
    case SET_IS_PLANNING_STATUS_UPDATE:
      return {
        ...state,
        isPlanningStatuses: action.payload,
      };
    case SET_STATUS_UPDATE_PLAN: {
      const fields = Object.keys(action.payload?.updates?.[0] || {});
      return {
        ...state,
        importTime: new Date(),
        plannedUpdatedStatus: action.payload,
        filtersStatusUpdate: fields,
      };
    }
    case SET_IS_APPLYING_STATUS_UPDATE:
      return {
        ...state,
        isApplyingStatuses: action.payload,
      };
    case SET_STATUS_UPDATE_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case RESET_IMPORT_STATUS_UPDATE:
      return {
        ...state,
        isPlanningStatuses: false,
        isApplyingStatuses: false,
        plannedUpdatedStatus: null,
        fileName: null,
        fileContents: null,
      };
    case SET_STATUS_UPDATE_MODE:
      return {
        ...state,
        statusUpdateMode: action.payload,
      };
    default:
      return state;
  }
};
